(function () {
  let acceptedAtKey = "terms_accepted_at";
  let firstAcceptedAtKey = "terms_first_accepted_at";
  let evidenceKey = "terms_acceptance_evidence";
  let ipKey = "terms_accepted_ip";
  let userAgentKey = "terms_user_agent";
  let versionKey = "terms_version";
  let sha256Key = "terms_sha256";
  let acceptedContentSha256Key = "terms_accepted_content_sha256";
  let contentCapturedAtKey = "terms_content_captured_at";
  let contentLengthKey = "terms_content_length";
  let contentChunkCountKey = "terms_content_chunk_count";
  let contentChunkPrefix = "terms_content_chunk_";
  let acceptanceUrlKey = "terms_acceptance_url";
  let termsUrlKey = "terms_url";
  let sessionIdKey = "terms_session_id";
  let checkboxStateKey = "terms_checkbox_state";
  let signatureNameKey = "terms_signature_name";
  let signatureAtKey = "terms_signature_at";
  let orderNameExpectedKey = "terms_order_name_expected";
  let nameMatchedKey = "terms_name_matched";
  let scrolledToEndKey = "terms_scrolled_to_end";
  let scrollCompletedAtKey = "terms_scroll_completed_at";
  let acceptanceMethodKey = "terms_acceptance_method";
  let capturePathKey = "terms_capture_path";
  let signatureDrawnKey = "terms_signature_drawn";
  let signatureImageSha256Key = "terms_signature_image_sha256";
  let signatureDecodeUrlKey = "terms_signature_decode_url";
  let signedSummaryKey = "terms_signed_summary";
  let evidenceStoreFailedKey = "terms_evidence_store_failed";
  let signatureDecodeUrl =
    "https://perfect-stingray-677.convex.site/tools/terms-signature-decoder";
  let termsEvidenceStoreUrl =
    "https://perfect-stingray-677.convex.site/terms-evidence/store";
  let storagePrefix = "electro_terms_first_accepted_";
  let clientIpStorageKey = "electro_client_ip";
  let sessionStorageKey = "electro_terms_session_id";
  let termsSignedSessionKey = "electro_terms_signed";
  let userAgentMaxLength = 512;
  let evidenceMaxLength = 4000;
  let contentChunkSize = 8000;
  let maxContentChunks = 40;
  let ipLookupUrl = "https://api.ipify.org?format=json";
  let scrollThreshold = 24;
  let termsFetchMaxAttempts = 10;
  let termsFetchRetryDelayMs = 400;
  let termsCacheStoragePrefix = "electro_terms_content_cache:";
  let acceptanceMethodValue = "scroll_draw_and_esign";
  let signatureValidityMs = 24 * 60 * 60 * 1000;
  let capturePathValues = {
    cartEsign: "cart_esign",
    shopExpress: "shop_express",
    unknown: "unknown",
  };
  let modalState = {
    hasScrolledToEnd: false,
    onComplete: null,
    scrollCompletedAt: "",
    signaturePad: null,
    termsSnapshot: null,
  };
  let modalDraft = {
    contentScrollRatio: 0,
    contentScrollTop: 0,
    hasScrolledToEnd: false,
    scrollCompletedAt: "",
    signatureImageBase64: "",
    signatureName: "",
  };
  let signedInSession = false;
  let signedAtInSession = "";
  let signatureExpirationCleanupPromise = null;
  let signatureExpirationTimer = null;
  let dynamicCheckoutGateSelector = "[data-terms-dynamic-checkout]";
  let dynamicCheckoutGateClass = "terms-dynamic-checkout-gate";
  let dynamicCheckoutReadyClass = "terms-dynamic-checkout-ready";
  let dynamicCheckoutCaptureBoundAttr = "data-terms-dynamic-checkout-capture-bound";
  let dynamicCheckoutObserver = null;
  let dynamicCheckoutRefreshFrame = null;
  let checkoutDiagnosticInteractionsBound = false;
  let checkoutDiagnosticsSeen = {};
  let savedPageScrollY = 0;
  let modalScrollGuardsBound = false;

  function getStrings() {
    if (!window.theme || !window.theme.strings) {
      return {};
    }

    return window.theme.strings;
  }

  function getThemeSettings() {
    if (!window.theme || !window.theme.settings) {
      return {};
    }

    return window.theme.settings;
  }

  function getCustomerKey() {
    if (window.theme && window.theme.customer && window.theme.customer.id) {
      return storagePrefix + window.theme.customer.id;
    }

    return storagePrefix + "guest";
  }

  function readStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {}
  }

  function readSessionStorage(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeSessionStorage(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {}
  }

  function getFirstAcceptedAt() {
    if (
      window.theme &&
      window.theme.customer &&
      window.theme.customer.termsFirstAcceptedAt
    ) {
      return window.theme.customer.termsFirstAcceptedAt;
    }

    return readStorage(getCustomerKey());
  }

  function rememberFirstAcceptedAt(isoString) {
    writeStorage(getCustomerKey(), isoString);
  }

  function getIsoTimestamp() {
    return new Date().toISOString();
  }

  function getSessionId() {
    let sessionId = readSessionStorage(sessionStorageKey);

    if (sessionId) {
      return sessionId;
    }

    if (window.crypto && window.crypto.randomUUID) {
      sessionId = window.crypto.randomUUID();
    } else {
      sessionId = "session-" + getIsoTimestamp() + "-" + Math.random().toString(36).slice(2);
    }

    writeSessionStorage(sessionStorageKey, sessionId);
    return sessionId;
  }

  function truncateValue(value, maxLength) {
    if (!value) {
      return "";
    }

    if (value.length <= maxLength) {
      return value;
    }

    return value.slice(0, maxLength);
  }

  function normalizeName(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, "")
      .replace(/\s+/g, " ");
  }

  function namesMatch(left, right) {
    let normalizedLeft = normalizeName(left);
    let normalizedRight = normalizeName(right);

    if (!normalizedLeft || !normalizedRight) {
      return false;
    }

    return normalizedLeft === normalizedRight;
  }

  function getCustomerName() {
    if (window.theme && window.theme.customer && window.theme.customer.name) {
      return window.theme.customer.name;
    }

    return "";
  }

  function isLoggedInCustomer() {
    return Boolean(getCustomerName());
  }

  function formatSignedDate(isoString) {
    let date = new Date(isoString);

    if (Number.isNaN(date.getTime())) {
      return isoString;
    }

    return date.toLocaleString();
  }

  function getTermsUrl() {
    let settings = getThemeSettings();
    return settings.termsConditionsUrl || "";
  }

  function getAbsoluteTermsUrl() {
    let termsUrl = getTermsUrl();

    if (!termsUrl) {
      return "";
    }

    if (termsUrl.indexOf("shopify://policies/") === 0) {
      return window.location.origin + "/policies/" + termsUrl.replace("shopify://policies/", "");
    }

    if (termsUrl.indexOf("http://") === 0 || termsUrl.indexOf("https://") === 0) {
      return termsUrl;
    }

    return window.location.origin + termsUrl;
  }

  function getTermsVersion() {
    let settings = getThemeSettings();
    return settings.termsConditionsVersion || "";
  }

  function getTermsSha256() {
    let settings = getThemeSettings();
    return settings.termsConditionsSha256 || "";
  }

  function getPolicyContentElement(doc) {
    if (!doc) {
      return null;
    }

    let selectors = [
      ".shopify-policy__body",
      ".shopify-policy__container",
      "main .rte",
      "main",
      "[role='main']",
    ];

    for (let index = 0; index < selectors.length; index += 1) {
      let element = doc.querySelector(selectors[index]);

      if (element && element.textContent && element.textContent.trim()) {
        return element;
      }
    }

    return doc.body || null;
  }

  function htmlToPlainText(html) {
    if (!html) {
      return "";
    }

    let doc = new DOMParser().parseFromString(html, "text/html");
    let contentElement = getPolicyContentElement(doc);

    if (!contentElement) {
      return "";
    }

    return contentElement.textContent
      .replace(/\r\n/g, "\n")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
  }

  function bufferToHex(buffer) {
    return Array.prototype.map
      .call(new Uint8Array(buffer), function (byte) {
        return byte.toString(16).padStart(2, "0");
      })
      .join("");
  }

  function hashText(text) {
    if (!text || !window.crypto || !window.crypto.subtle) {
      return Promise.resolve("");
    }

    let encoder = new TextEncoder();
    let encoded = encoder.encode(text);

    return window.crypto.subtle.digest("SHA-256", encoded).then(bufferToHex);
  }

  function delayMs(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function getTermsCacheKey() {
    return termsCacheStoragePrefix + getTermsVersion() + ":" + getTermsSha256();
  }

  function readCachedTermsSnapshot() {
    let raw = readStorage(getTermsCacheKey());

    if (!raw) {
      return null;
    }

    try {
      let parsed = JSON.parse(raw);

      if (parsed && parsed.fetchSucceeded && parsed.content) {
        return parsed;
      }
    } catch (error) {}

    return null;
  }

  function writeCachedTermsSnapshot(snapshot) {
    if (!snapshot || !snapshot.fetchSucceeded || !snapshot.content) {
      return;
    }

    writeStorage(getTermsCacheKey(), JSON.stringify(snapshot));
  }

  function getEmbeddedTermsHtml() {
    let node = document.getElementById("terms-embedded-content");

    if (!node || !node.textContent) {
      return "";
    }

    try {
      let parsed = JSON.parse(node.textContent);
      return typeof parsed === "string" ? parsed : "";
    } catch (error) {
      return "";
    }
  }

  function createTermsFetchError(error) {
    if (error && typeof error.status === "number") {
      return {
        message: "http_" + error.status,
        status: error.status,
        statusText: error.statusText || "",
        type: "http",
      };
    }

    if (error instanceof Response) {
      return {
        message: "http_" + error.status,
        status: error.status,
        statusText: error.statusText || "",
        type: "http",
      };
    }

    if (error instanceof Error) {
      return {
        message: error.message || "error",
        type: error.name || "error",
      };
    }

    return {
      message: String(error || "unknown"),
      type: "unknown",
    };
  }

  function buildTermsSnapshotFromHtml(html, sourceUrl, contentSource) {
    let content = htmlToPlainText(html);
    let capturedAt = getIsoTimestamp();

    if (!content) {
      return Promise.resolve({
        capturedAt: capturedAt,
        content: "",
        contentSha256: "",
        contentSource: contentSource,
        fetchSucceeded: false,
        lastError: createTermsFetchError(new Error("terms_content_empty")),
        sourceUrl: sourceUrl,
      });
    }

    return hashText(content).then(function (contentSha256) {
      return {
        capturedAt: capturedAt,
        content: content,
        contentSha256: contentSha256,
        contentSource: contentSource,
        fetchSucceeded: true,
        sourceUrl: sourceUrl,
      };
    });
  }

  function logTermsLoadFailure(snapshot, attempt, error) {
    let failure = createTermsFetchError(error || (snapshot && snapshot.lastError));
    let payload = {
      attempt: attempt,
      contentLength: snapshot && snapshot.content ? snapshot.content.length : 0,
      contentSource: snapshot && snapshot.contentSource ? snapshot.contentSource : "unknown",
      environment: getSentryEnvironment(),
      failureMessage: failure.message,
      failureStatus: failure.status,
      failureStatusText: failure.statusText,
      failureType: failure.type,
      fetchSucceeded: Boolean(snapshot && snapshot.fetchSucceeded),
      host: window.location.hostname,
      sourceUrl: snapshot && snapshot.sourceUrl ? snapshot.sourceUrl : getAbsoluteTermsUrl(),
    };

    console.warn("termsAcceptance: unable to load terms content", payload, error);
  }

  function fetchTermsSnapshotOnce() {
    let absoluteTermsUrl = getAbsoluteTermsUrl();

    if (!absoluteTermsUrl) {
      return Promise.resolve({
        capturedAt: getIsoTimestamp(),
        content: "",
        contentSha256: "",
        contentSource: "network",
        fetchSucceeded: false,
        lastError: createTermsFetchError(new Error("terms_url_missing")),
        sourceUrl: "",
      });
    }

    return fetch(absoluteTermsUrl, {
      credentials: "same-origin",
      headers: {
        Accept: "text/html,application/xhtml+xml",
      },
    })
      .then(function (response) {
        if (!response.ok) {
          throw {
            message: "http_" + response.status,
            status: response.status,
            statusText: response.statusText || "",
            type: "http",
          };
        }

        return response.text();
      })
      .then(function (html) {
        return buildTermsSnapshotFromHtml(html, absoluteTermsUrl, "network");
      });
  }

  function fetchTermsSnapshotAttempt(attempt, lastError) {
    return fetchTermsSnapshotOnce()
      .then(function (snapshot) {
        if (snapshot.fetchSucceeded && snapshot.content) {
          return snapshot;
        }

        let error = snapshot.lastError || lastError || createTermsFetchError(new Error("terms_snapshot_empty"));

        if (attempt >= termsFetchMaxAttempts) {
          snapshot.lastError = error;
          return snapshot;
        }

        return delayMs(termsFetchRetryDelayMs * attempt).then(function () {
          return fetchTermsSnapshotAttempt(attempt + 1, error);
        });
      })
      .catch(function (error) {
        let described = createTermsFetchError(error);

        if (attempt >= termsFetchMaxAttempts) {
          return {
            capturedAt: getIsoTimestamp(),
            content: "",
            contentSha256: "",
            contentSource: "network",
            fetchSucceeded: false,
            lastError: described,
            sourceUrl: getAbsoluteTermsUrl(),
          };
        }

        return delayMs(termsFetchRetryDelayMs * attempt).then(function () {
          return fetchTermsSnapshotAttempt(attempt + 1, described);
        });
      });
  }

  function resolveTermsSnapshotFromSources() {
    let embeddedHtml = getEmbeddedTermsHtml();

    if (embeddedHtml) {
      return buildTermsSnapshotFromHtml(embeddedHtml, getAbsoluteTermsUrl(), "embedded");
    }

    let cachedSnapshot = readCachedTermsSnapshot();

    if (cachedSnapshot) {
      return Promise.resolve(
        Object.assign({}, cachedSnapshot, {
          contentSource: cachedSnapshot.contentSource || "cache",
        }),
      );
    }

    return fetchTermsSnapshotAttempt(1, null);
  }

  function fetchTermsSnapshot() {
    if (
      modalState.termsSnapshot &&
      modalState.termsSnapshot.fetchSucceeded &&
      modalState.termsSnapshot.content
    ) {
      return Promise.resolve(modalState.termsSnapshot);
    }

    return resolveTermsSnapshotFromSources().then(function (snapshot) {
      if (snapshot.fetchSucceeded && snapshot.content) {
        writeCachedTermsSnapshot(snapshot);
        modalState.termsSnapshot = snapshot;
        return snapshot;
      }

      logTermsLoadFailure(snapshot, termsFetchMaxAttempts, snapshot.lastError);
      modalState.termsSnapshot = null;
      return snapshot;
    });
  }

  function prefetchTermsSnapshot() {
    fetchTermsSnapshot().then(function () {}).catch(function () {});
  }

  function chunkContent(content) {
    let chunks = [];

    if (!content) {
      return chunks;
    }

    for (let index = 0; index < content.length; index += contentChunkSize) {
      if (chunks.length >= maxContentChunks) {
        break;
      }

      chunks.push(content.slice(index, index + contentChunkSize));
    }

    return chunks;
  }

  function createSignaturePad(canvas) {
    let context = canvas.getContext("2d");
    let drawing = false;
    let hasInk = false;
    let lastPoint = null;
    let changeHandler = null;

    function triggerChange() {
      if (typeof changeHandler === "function") {
        changeHandler();
      }
    }

    function getPoint(event) {
      let rect = canvas.getBoundingClientRect();
      let clientX = 0;
      let clientY = 0;

      if (event.touches && event.touches.length) {
        clientX = event.touches[0].clientX;
        clientY = event.touches[0].clientY;
      } else if (event.changedTouches && event.changedTouches.length) {
        clientX = event.changedTouches[0].clientX;
        clientY = event.changedTouches[0].clientY;
      } else {
        clientX = event.clientX;
        clientY = event.clientY;
      }

      return {
        x: clientX - rect.left,
        y: clientY - rect.top,
      };
    }

    function startStroke(event) {
      if (event.cancelable) {
        event.preventDefault();
      }

      drawing = true;
      lastPoint = getPoint(event);
    }

    function drawStroke(event) {
      if (!drawing) {
        return;
      }

      if (event.cancelable) {
        event.preventDefault();
      }

      let point = getPoint(event);
      context.beginPath();
      context.moveTo(lastPoint.x, lastPoint.y);
      context.lineTo(point.x, point.y);
      context.stroke();
      lastPoint = point;
      hasInk = true;
      triggerChange();
    }

    function endStroke(event) {
      if (!drawing) {
        return;
      }

      if (event.cancelable) {
        event.preventDefault();
      }

      drawing = false;
      lastPoint = null;
    }

    function resize() {
      let savedDataUrl = hasInk ? canvas.toDataURL("image/png") : "";
      let rect = canvas.getBoundingClientRect();
      let ratio = window.devicePixelRatio || 1;
      let nextWidth = Math.floor(rect.width * ratio);
      let nextHeight = Math.floor(rect.height * ratio);

      if (!nextWidth || !nextHeight) {
        return Promise.resolve();
      }

      canvas.width = nextWidth;
      canvas.height = nextHeight;
      context.setTransform(1, 0, 0, 1, 0, 0);
      context.scale(ratio, ratio);
      context.strokeStyle = "#111111";
      context.lineWidth = 2.5;
      context.lineCap = "round";
      context.lineJoin = "round";

      if (savedDataUrl) {
        return loadFromDataUrl(savedDataUrl);
      }

      hasInk = false;
      triggerChange();
      return Promise.resolve();
    }

    function clear() {
      let rect = canvas.getBoundingClientRect();
      context.clearRect(0, 0, rect.width, rect.height);
      hasInk = false;
      triggerChange();
    }

    function loadFromDataUrl(dataUrl) {
      if (!dataUrl) {
        clear();
        return Promise.resolve();
      }

      return new Promise(function (resolve) {
        let image = document.createElement("img");

        image.onload = function () {
          let rect = canvas.getBoundingClientRect();
          context.clearRect(0, 0, rect.width, rect.height);
          context.drawImage(image, 0, 0, rect.width, rect.height);
          hasInk = true;
          triggerChange();
          resolve();
        };

        image.onerror = function () {
          clear();
          resolve();
        };

        image.src = dataUrl;
      });
    }

    function loadFromBase64(base64) {
      if (!base64) {
        clear();
        return Promise.resolve();
      }

      return loadFromDataUrl("data:image/png;base64," + base64);
    }

    function isEmpty() {
      return !hasInk;
    }

    function toPngBase64() {
      let dataUrl = canvas.toDataURL("image/png");
      let parts = dataUrl.split(",");

      if (parts.length < 2) {
        return "";
      }

      return parts[1];
    }

    function onChange(handler) {
      changeHandler = handler;
    }

    canvas.addEventListener("mousedown", startStroke);
    canvas.addEventListener("mousemove", drawStroke);
    canvas.addEventListener("mouseup", endStroke);
    canvas.addEventListener("mouseleave", endStroke);
    canvas.addEventListener("touchstart", startStroke, { passive: false });
    canvas.addEventListener("touchmove", drawStroke, { passive: false });
    canvas.addEventListener("touchend", endStroke, { passive: false });
    canvas.addEventListener("touchcancel", endStroke, { passive: false });

    return {
      clear: clear,
      isEmpty: isEmpty,
      loadFromBase64: loadFromBase64,
      loadFromDataUrl: loadFromDataUrl,
      onChange: onChange,
      resize: resize,
      toPngBase64: toPngBase64,
    };
  }

  function initSignaturePad() {
    let elements = getModalElements();

    if (!elements || !elements.signatureCanvas) {
      return null;
    }

    if (modalState.signaturePad) {
      return modalState.signaturePad;
    }

    modalState.signaturePad = createSignaturePad(elements.signatureCanvas);
    modalState.signaturePad.onChange(updateSubmitState);

    if (elements.signatureClear) {
      elements.signatureClear.addEventListener("click", function () {
        if (modalState.signaturePad) {
          modalState.signaturePad.clear();
        }
      });
    }

    return modalState.signaturePad;
  }

  function resizeSignaturePad() {
    if (!modalState.signaturePad) {
      return Promise.resolve();
    }

    return modalState.signaturePad.resize();
  }

  function getClientIp() {
    let cachedIp = readSessionStorage(clientIpStorageKey);

    if (cachedIp) {
      return Promise.resolve(cachedIp);
    }

    return fetch(ipLookupUrl, {
      credentials: "omit",
      headers: {
        Accept: "application/json",
      },
    })
      .then(function (response) {
        if (!response.ok) {
          throw response;
        }

        return response.json();
      })
      .then(function (payload) {
        let ip = payload && payload.ip ? payload.ip : "";

        if (ip) {
          writeSessionStorage(clientIpStorageKey, ip);
        }

        return ip;
      })
      .catch(function () {
        return "";
      });
  }

  function buildEvidenceRecord(options) {
    let settings = getThemeSettings();
    let now = options.timestampUtc || getIsoTimestamp();
    let firstAt = options.firstAcceptedAtUtc || getFirstAcceptedAt() || now;
    let customerId =
      window.theme && window.theme.customer && window.theme.customer.id
        ? window.theme.customer.id
        : null;
    let termsSnapshot = options.termsSnapshot || {};

    return {
      accepted: true,
      acceptanceMethod: acceptanceMethodValue,
      timestampUtc: now,
      firstAcceptedAtUtc: firstAt,
      ip: options.ip || "",
      userAgent: truncateValue(options.userAgent || "", userAgentMaxLength),
      termsVersion: getTermsVersion(),
      termsSha256: getTermsSha256(),
      termsAcceptedContentSha256: termsSnapshot.contentSha256 || "",
      termsContentCapturedAt: termsSnapshot.capturedAt || "",
      termsContentLength: termsSnapshot.content ? termsSnapshot.content.length : 0,
      termsContentFetchSucceeded: termsSnapshot.fetchSucceeded === true,
      termsContentSourceUrl: termsSnapshot.sourceUrl || getAbsoluteTermsUrl(),
      termsUrl: getTermsUrl(),
      acceptanceUrl: options.acceptanceUrl || window.location.href,
      sessionId: options.sessionId || getSessionId(),
      customerId: customerId,
      checkboxState: options.checkboxState !== false,
      signatureName: options.signatureName || "",
      signatureAt: options.signatureAt || "",
      orderNameExpected: options.orderNameExpected || "",
      nameMatched: options.nameMatched === true,
      scrolledToEnd: options.scrolledToEnd === true,
      scrollCompletedAt: options.scrollCompletedAt || "",
      cartType: settings.cartType || "",
      shopDomain: window.Shopify && window.Shopify.shop ? window.Shopify.shop : "",
      termsCapturePath: options.termsCapturePath || capturePathValues.cartEsign,
      signatureDrawn: options.signatureDrawn === true,
      signatureImageFormat: options.signatureImageFormat || "",
      signatureImageSha256: options.signatureImageSha256 || "",
      signatureImageChunkCount: options.signatureImageChunkCount || 0,
    };
  }

  function buildSignedSummary(evidence) {
    let name = evidence.signatureName || "Unknown";
    let version = evidence.termsVersion || "";
    let signedAt = evidence.signatureAt || evidence.timestampUtc || "";

    return (
      name +
      " · scroll+draw · " +
      version +
      (signedAt ? " · " + signedAt : "")
    );
  }

  function parseEvidenceStoreError(error) {
    if (error && typeof error.status === "number") {
      return {
        message: "terms evidence store HTTP " + error.status,
        status: error.status,
        type: "http",
      };
    }

    if (error && error.message) {
      return {
        message: error.message,
        type: "error",
      };
    }

    return {
      message: "terms evidence store unknown error",
      type: "unknown",
    };
  }

  function getSentryEnvironment() {
    if (window.theme && window.theme.sentryEnvironment) {
      return window.theme.sentryEnvironment;
    }

    let host = window.location.hostname;

    if (host === "127.0.0.1" || host === "localhost") {
      return "local";
    }

    if (host === "electroandcompany.com" || host === "www.electroandcompany.com") {
      return "production";
    }

    if (host.indexOf("myshopify.com") !== -1) {
      return "preview";
    }

    return "production";
  }

  function logEvidenceStoreFailure(error, context) {
    let parsed = parseEvidenceStoreError(error);
    let payload = {
      capturePath: context && context.capturePath ? context.capturePath : "",
      environment: getSentryEnvironment(),
      host: window.location.hostname,
      sessionId: context && context.sessionId ? context.sessionId : "",
      shopDomain: context && context.shopDomain ? context.shopDomain : "",
      signatureName: context && context.signatureName ? context.signatureName : "",
      status: parsed.status || null,
      type: parsed.type,
    };

    console.warn("termsAcceptance: evidence store failed, allowing checkout", payload, error);

    if (window.Sentry && typeof window.Sentry.captureMessage === "function") {
      window.Sentry.captureMessage(parsed.message, {
        extra: payload,
        level: "warning",
        tags: {
          environment: getSentryEnvironment(),
          evidenceStore: "convex",
          feature: "terms_acceptance",
          host: window.location.hostname,
        },
      });
    }
  }

  function flattenEvidenceForCart(evidence, termsSnapshot, signatureImageBase64) {
    let attributes = {
      [capturePathKey]: evidence.termsCapturePath,
      [signatureNameKey]: truncateValue(evidence.signatureName, 256),
      [signatureAtKey]: evidence.signatureAt || evidence.timestampUtc,
      [versionKey]: evidence.termsVersion,
      [acceptanceMethodKey]: acceptanceMethodValue,
      [scrolledToEndKey]: evidence.scrolledToEnd ? "true" : "false",
      [signedSummaryKey]: truncateValue(buildSignedSummary(evidence), 512),
      [signatureDecodeUrlKey]: signatureDecodeUrl,
      [sessionIdKey]: evidence.sessionId,
    };

    if (signatureImageBase64) {
      attributes[signatureDrawnKey] = "true";
      attributes[signatureImageSha256Key] = evidence.signatureImageSha256 || "";
    }

    return attributes;
  }

  function postTermsEvidenceToConvex(evidence, termsSnapshot, signatureImageBase64) {
    let settings = getThemeSettings();
    let storeKey = settings.termsEvidenceStoreKey || "";
    let snapshot = termsSnapshot || {};

    if (!storeKey) {
      return Promise.reject(new Error("missing_terms_evidence_store_key"));
    }

    return fetch(termsEvidenceStoreUrl, {
      method: "POST",
      body: JSON.stringify({
        acceptanceMethod: evidence.acceptanceMethod,
        acceptanceUrl: evidence.acceptanceUrl,
        acceptedAt: evidence.timestampUtc,
        acceptedIp: evidence.ip,
        capturePath: evidence.termsCapturePath,
        customerId: evidence.customerId,
        firstAcceptedAt: evidence.firstAcceptedAtUtc,
        nameMatched: evidence.nameMatched === true,
        orderNameExpected: evidence.orderNameExpected,
        scrollCompletedAt: evidence.scrollCompletedAt,
        scrolledToEnd: evidence.scrolledToEnd === true,
        sessionId: evidence.sessionId,
        shopDomain: evidence.shopDomain,
        signatureAt: evidence.signatureAt || evidence.timestampUtc,
        signatureImageBase64: signatureImageBase64,
        signatureImageSha256: evidence.signatureImageSha256 || "",
        signatureName: evidence.signatureName,
        signedSummary: buildSignedSummary(evidence),
        termsAcceptedContentSha256: evidence.termsAcceptedContentSha256 || snapshot.contentSha256 || "",
        termsContentCapturedAt: evidence.termsContentCapturedAt || snapshot.capturedAt || "",
        termsContentFetchSucceeded:
          evidence.termsContentFetchSucceeded === true || snapshot.fetchSucceeded === true,
        termsContentLength: evidence.termsContentLength || (snapshot.content ? snapshot.content.length : 0),
        termsContentSourceUrl: evidence.termsContentSourceUrl || snapshot.sourceUrl || "",
        termsContentText: snapshot.content || "",
        termsSha256: evidence.termsSha256,
        termsUrl: evidence.termsUrl,
        termsVersion: evidence.termsVersion,
        userAgent: evidence.userAgent,
      }),
      credentials: "omit",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Terms-Evidence-Key": storeKey,
      },
    }).then(function (response) {
      if (!response.ok) {
        throw response;
      }

      return response.json();
    });
  }

  function setCapturePath(path) {
    let attributes = {};
    attributes[capturePathKey] = path;
    return updateCartAttributes(attributes);
  }

  function fetchCartState() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
      },
    }).then(function (response) {
      if (!response.ok) {
        throw response;
      }

      return response.json();
    });
  }

  function syncCapturePathStateFromCart() {
    if (!requiresSignature()) {
      return Promise.resolve();
    }

    return fetchCartState()
      .then(function (cart) {
        return syncTermsSignedSessionWithCart(cart).then(function () {
          let attributes = cart.attributes || {};
          let capturePath = attributes[capturePathKey];

          if (isSigned()) {
            if (capturePath !== capturePathValues.cartEsign) {
              return setCapturePath(capturePathValues.cartEsign);
            }

            return null;
          }

          if (document.querySelector("[data-terms-panel]") && !capturePath) {
            return setCapturePath(capturePathValues.unknown);
          }

          if (capturePath === capturePathValues.shopExpress) {
            return setCapturePath(capturePathValues.unknown);
          }

          return null;
        });
      })
      .catch(function () {
        return null;
      });
  }

  function updateCartAttributes(attributes) {
    return fetch("/cart/update.js", {
      method: "POST",
      body: JSON.stringify({
        attributes: attributes,
      }),
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (!response.ok) {
        throw response;
      }

      return response.json();
    });
  }

  function getModalElements() {
    let modal = document.querySelector("[data-terms-modal]");

    if (!modal) {
      return null;
    }

    return {
      closeButton: modal.querySelector("[data-terms-close]"),
      content: modal.querySelector("[data-terms-content]"),
      error: modal.querySelector("[data-terms-error]"),
      modal: modal,
      scrollHint: modal.querySelector("[data-terms-scroll-hint]"),
      signature: modal.querySelector("[data-terms-signature]"),
      signatureCanvas: modal.querySelector("[data-terms-signature-canvas]"),
      signatureClear: modal.querySelector("[data-terms-signature-clear]"),
      signatureName: modal.querySelector("[data-terms-signature-name]"),
      submitButton: modal.querySelector("[data-terms-submit]"),
    };
  }

  function setModalError(message) {
    let elements = getModalElements();

    if (!elements || !elements.error) {
      return;
    }

    if (!message) {
      elements.error.textContent = "";
      elements.error.classList.remove("is-visible");
      return;
    }

    elements.error.textContent = message;
    elements.error.classList.add("is-visible");
  }

  function updateSubmitState() {
    let elements = getModalElements();

    if (!elements || !elements.submitButton) {
      return;
    }

    let fullNameValue = elements.signatureName ? elements.signatureName.value.trim() : "";
    let hasRequiredName = Boolean(fullNameValue);

    let hasDrawnSignature = Boolean(
      modalState.signaturePad && !modalState.signaturePad.isEmpty(),
    );

    elements.submitButton.disabled =
      !modalState.hasScrolledToEnd || !hasRequiredName || !hasDrawnSignature;
  }

  function runAfterModalLayout(callback) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(callback);
    });
  }

  function lockPageScroll() {
    savedPageScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add("terms-acceptance-modal-open");
    document.body.classList.add("terms-acceptance-modal-open");
    document.body.style.position = "fixed";
    document.body.style.top = "-" + savedPageScrollY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove("terms-acceptance-modal-open");
    document.body.classList.remove("terms-acceptance-modal-open");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    window.scrollTo(0, savedPageScrollY);
  }

  function syncTermsScrollState(elements) {
    if (!elements) {
      elements = getModalElements();
    }

    if (!elements || !elements.content) {
      return;
    }

    let reachedBottom =
      elements.content.scrollTop + elements.content.clientHeight >=
      elements.content.scrollHeight - scrollThreshold;

    if (reachedBottom) {
      markScrollComplete(elements);
    }
  }

  function refreshTermsModalLayout(elements) {
    if (!elements) {
      elements = getModalElements();
    }

    if (!elements) {
      return;
    }

    checkScrollableContent(elements);
    syncTermsScrollState(elements);

    if (modalState.hasScrolledToEnd) {
      runAfterModalLayout(function () {
        resizeSignaturePad();
      });
    }
  }

  function handleTermsContentWheel(event) {
    let content = event.currentTarget;

    if (!content || content.scrollHeight <= content.clientHeight + scrollThreshold) {
      event.preventDefault();
      return;
    }

    let atTop = content.scrollTop <= 0;
    let atBottom =
      content.scrollTop + content.clientHeight >= content.scrollHeight - scrollThreshold;
    let scrollingUp = event.deltaY < 0;
    let scrollingDown = event.deltaY > 0;

    if ((scrollingUp && atTop) || (scrollingDown && atBottom)) {
      event.preventDefault();
    }
  }

  function handleModalWheel(event) {
    let elements = getModalElements();

    if (!elements || !elements.modal) {
      return;
    }

    if (event.target === elements.modal) {
      event.preventDefault();
    }
  }

  function bindModalScrollGuards() {
    let elements = getModalElements();

    if (!elements || modalScrollGuardsBound) {
      return;
    }

    modalScrollGuardsBound = true;

    if (elements.content) {
      elements.content.addEventListener("wheel", handleTermsContentWheel, { passive: false });
    }

    if (elements.modal) {
      elements.modal.addEventListener("wheel", handleModalWheel, { passive: false });
    }
  }

  function markScrollComplete(elements) {
    if (modalState.hasScrolledToEnd) {
      return;
    }

    modalState.hasScrolledToEnd = true;
    modalState.scrollCompletedAt = getIsoTimestamp();

    if (elements.scrollHint) {
      elements.scrollHint.textContent =
        getStrings().termsEsignScrollComplete || "Print and sign your name below to continue";
      elements.scrollHint.classList.add("is-complete");
    }

    if (elements.signature) {
      elements.signature.classList.add("is-enabled");
    }

    runAfterModalLayout(function () {
      resizeSignaturePad();

      if (elements.signature) {
        elements.signature.scrollIntoView({ block: "nearest" });
      }
    });

    updateSubmitState();
  }

  function handleTermsScroll(event) {
    let container = event.currentTarget;
    let elements = getModalElements();

    if (!container) {
      return;
    }

    let reachedBottom =
      container.scrollTop + container.clientHeight >= container.scrollHeight - scrollThreshold;

    if (reachedBottom) {
      markScrollComplete(elements);
    }
  }

  function checkScrollableContent(elements) {
    if (!elements || !elements.content) {
      return;
    }

    if (elements.content.scrollHeight <= elements.content.clientHeight + scrollThreshold) {
      markScrollComplete(elements);
    }
  }

  function configureFullNameField(elements) {
    if (!elements || !elements.signatureName) {
      return;
    }

    let customerName = getCustomerName();

    if (customerName) {
      elements.signatureName.value = customerName;
      elements.signatureName.readOnly = true;
      return;
    }

    elements.signatureName.value = "";
    elements.signatureName.readOnly = false;
  }

  function hasModalDraft() {
    return Boolean(
      modalDraft.hasScrolledToEnd ||
        modalDraft.signatureName ||
        modalDraft.signatureImageBase64 ||
        modalDraft.contentScrollTop > 0,
    );
  }

  function clearModalDraft() {
    modalDraft.contentScrollRatio = 0;
    modalDraft.contentScrollTop = 0;
    modalDraft.hasScrolledToEnd = false;
    modalDraft.scrollCompletedAt = "";
    modalDraft.signatureImageBase64 = "";
    modalDraft.signatureName = "";
  }

  function captureContentScrollDraft(content) {
    if (!content) {
      return {
        scrollRatio: 0,
        scrollTop: 0,
      };
    }

    let maxScroll = content.scrollHeight - content.clientHeight;

    return {
      scrollRatio: maxScroll > 0 ? content.scrollTop / maxScroll : 0,
      scrollTop: content.scrollTop,
    };
  }

  function applySavedTermsScrollPosition(elements) {
    if (!elements || !elements.content || !hasModalDraft() || isSigned()) {
      return;
    }

    let content = elements.content;

    if (modalDraft.hasScrolledToEnd) {
      content.scrollTop = content.scrollHeight;
      return;
    }

    let maxScroll = content.scrollHeight - content.clientHeight;

    if (maxScroll <= 0) {
      content.scrollTop = 0;
      return;
    }

    if (modalDraft.contentScrollRatio > 0) {
      content.scrollTop = Math.round(maxScroll * modalDraft.contentScrollRatio);
      return;
    }

    content.scrollTop = Math.min(modalDraft.contentScrollTop, maxScroll);
  }

  function captureModalDraft() {
    if (isSigned()) {
      return;
    }

    let elements = getModalElements();

    if (!elements) {
      return;
    }

    modalDraft.hasScrolledToEnd = modalState.hasScrolledToEnd;
    modalDraft.scrollCompletedAt = modalState.scrollCompletedAt;

    if (elements.content) {
      let scrollDraft = captureContentScrollDraft(elements.content);
      modalDraft.contentScrollTop = scrollDraft.scrollTop;
      modalDraft.contentScrollRatio = scrollDraft.scrollRatio;
    } else {
      modalDraft.contentScrollTop = 0;
      modalDraft.contentScrollRatio = 0;
    }

    if (elements.signatureName && !elements.signatureName.readOnly) {
      modalDraft.signatureName = elements.signatureName.value.trim();
    } else {
      modalDraft.signatureName = "";
    }

    if (modalState.signaturePad && !modalState.signaturePad.isEmpty()) {
      modalDraft.signatureImageBase64 = modalState.signaturePad.toPngBase64();
      return;
    }

    modalDraft.signatureImageBase64 = "";
  }

  function applyScrollCompleteUi(elements) {
    if (!elements) {
      return;
    }

    if (elements.scrollHint) {
      elements.scrollHint.textContent =
        getStrings().termsEsignScrollComplete || "Print and sign your name below to continue";
      elements.scrollHint.classList.add("is-complete");
    }

    if (elements.signature) {
      elements.signature.classList.add("is-enabled");
    }
  }

  function restoreModalDraftLayout(elements) {
    if (!elements || isSigned() || !hasModalDraft()) {
      return;
    }

    modalState.hasScrolledToEnd = modalDraft.hasScrolledToEnd;
    modalState.scrollCompletedAt = modalDraft.scrollCompletedAt;

    if (modalDraft.hasScrolledToEnd) {
      applyScrollCompleteUi(elements);
    } else if (elements.scrollHint) {
      elements.scrollHint.textContent =
        getStrings().termsEsignScrollHint || "Scroll to the bottom of the terms to continue";
      elements.scrollHint.classList.remove("is-complete");
    }

    configureFullNameField(elements);

    if (elements.signatureName && !elements.signatureName.readOnly && modalDraft.signatureName) {
      elements.signatureName.value = modalDraft.signatureName;
    }
  }

  function finalizeModalDraftRestore(elements) {
    if (!elements || isSigned() || !hasModalDraft()) {
      return Promise.resolve();
    }

    applySavedTermsScrollPosition(elements);
    syncTermsScrollState(elements);

    return new Promise(function (resolve) {
      runAfterModalLayout(function () {
        applySavedTermsScrollPosition(elements);
        syncTermsScrollState(elements);
        resolve();
      });
    });
  }

  function restoreModalDraftSignature() {
    if (!modalState.signaturePad || !modalDraft.signatureImageBase64 || isSigned()) {
      return Promise.resolve();
    }

    return modalState.signaturePad.loadFromBase64(modalDraft.signatureImageBase64);
  }

  function restoreModalDraft(elements) {
    restoreModalDraftLayout(elements);

    return restoreModalDraftSignature().then(function () {
      updateSubmitState();
    });
  }

  function resetModalForm() {
    let elements = getModalElements();

    modalState.hasScrolledToEnd = false;
    modalState.scrollCompletedAt = "";

    if (!elements) {
      return;
    }

    configureFullNameField(elements);
    setModalError("");

    if (elements.signatureName && !elements.signatureName.readOnly) {
      elements.signatureName.value = "";
    }

    if (elements.signature) {
      elements.signature.classList.remove("is-enabled");
    }

    if (elements.scrollHint) {
      elements.scrollHint.textContent =
        getStrings().termsEsignScrollHint || "Scroll to the bottom of the terms to continue";
      elements.scrollHint.classList.remove("is-complete");
    }

    if (elements.content) {
      elements.content.scrollTop = 0;
    }

    if (modalState.signaturePad) {
      modalState.signaturePad.clear();
    }

    updateSubmitState();
  }

  function prepareModalForm() {
    let elements = getModalElements();

    setModalError("");

    if (isSigned() || !hasModalDraft()) {
      resetModalForm();
      return;
    }

    modalState.hasScrolledToEnd = modalDraft.hasScrolledToEnd;
    modalState.scrollCompletedAt = modalDraft.scrollCompletedAt;

    if (!elements) {
      return;
    }

    if (modalDraft.hasScrolledToEnd) {
      applyScrollCompleteUi(elements);
    } else if (elements.signature) {
      elements.signature.classList.remove("is-enabled");
    }

    if (!modalDraft.hasScrolledToEnd && elements.scrollHint) {
      elements.scrollHint.textContent =
        getStrings().termsEsignScrollHint || "Scroll to the bottom of the terms to continue";
      elements.scrollHint.classList.remove("is-complete");
    }

    configureFullNameField(elements);
    updateSubmitState();
  }

  function loadTermsIntoModal() {
    let elements = getModalElements();
    let strings = getStrings();

    if (!elements || !elements.content) {
      return Promise.resolve();
    }

    if (
      modalState.termsSnapshot &&
      modalState.termsSnapshot.fetchSucceeded &&
      modalState.termsSnapshot.content
    ) {
      elements.content.classList.remove("is-loading");
      elements.content.textContent = modalState.termsSnapshot.content;
      return Promise.resolve();
    }

    elements.content.classList.add("is-loading");
    elements.content.textContent = strings.termsEsignLoading || "Loading terms...";

    return fetchTermsSnapshot().then(function (snapshot) {
      elements.content.classList.remove("is-loading");

      if (!snapshot.fetchSucceeded || !snapshot.content) {
        elements.content.textContent =
          strings.termsEsignLoadError || "Unable to load terms. Please try again.";
        return;
      }

      elements.content.textContent = snapshot.content;

      return new Promise(function (resolve) {
        runAfterModalLayout(function () {
          if (!hasModalDraft() || isSigned()) {
            refreshTermsModalLayout(elements);
          }

          resolve();
        });
      });
    });
  }

  function updatePanelStatus(signatureName, signedAt) {
    let strings = getStrings();
    let signedTemplate = strings.termsEsignSigned || "Signed by [name] on [date]";
    let signedText = signedTemplate
      .replace("[name]", signatureName)
      .replace("[date]", formatSignedDate(signedAt));

    document.querySelectorAll("[data-terms-status]").forEach(function (statusNode) {
      statusNode.classList.remove("terms-acceptance-panel__status--unsigned");
      statusNode.classList.add("terms-acceptance-panel__status--signed");

      let textNode = statusNode.querySelector("[data-terms-status-text]");

      if (textNode) {
        textNode.textContent = signedText;
      }
    });

    document.querySelectorAll("[data-terms-open]").forEach(function (button) {
      button.textContent = strings.termsEsignOpenSigned || "Review signed terms";
    });
  }

  function resetPanelStatus() {
    let strings = getStrings();

    document.querySelectorAll("[data-terms-status]").forEach(function (statusNode) {
      statusNode.classList.remove("terms-acceptance-panel__status--signed");
      statusNode.classList.add("terms-acceptance-panel__status--unsigned");

      let textNode = statusNode.querySelector("[data-terms-status-text]");

      if (textNode) {
        textNode.textContent = strings.termsEsignUnsigned || "Terms not yet reviewed and signed";
      }
    });

    document.querySelectorAll("[data-terms-open]").forEach(function (button) {
      button.textContent = strings.termsEsignOpen || "Review and sign terms";
    });
  }

  function getSignatureTimestamp(signedAt) {
    let timestamp = Date.parse(signedAt || "");
    return Number.isFinite(timestamp) ? timestamp : null;
  }

  function isSignatureExpired(signedAt, now) {
    let signedAtTimestamp = getSignatureTimestamp(signedAt);
    let currentTimestamp = typeof now === "number" ? now : Date.now();

    if (signedAtTimestamp === null) {
      return true;
    }

    return currentTimestamp - signedAtTimestamp >= signatureValidityMs;
  }

  function readTermsSignedSession() {
    let raw = readSessionStorage(termsSignedSessionKey);

    if (!raw) {
      return null;
    }

    try {
      let parsed = JSON.parse(raw);

      if (parsed && parsed.signatureName) {
        return parsed;
      }
    } catch (error) {}

    return null;
  }

  function writeTermsSignedSession(signatureName, signedAt, cartToken) {
    writeSessionStorage(
      termsSignedSessionKey,
      JSON.stringify({
        cartToken: cartToken || "",
        signatureName: signatureName,
        signedAt: signedAt || "",
      }),
    );
  }

  function clearTermsSignedSession() {
    try {
      sessionStorage.removeItem(termsSignedSessionKey);
    } catch (error) {}
  }

  function clearSignatureExpirationTimer() {
    if (!signatureExpirationTimer) {
      return;
    }

    window.clearTimeout(signatureExpirationTimer);
    signatureExpirationTimer = null;
  }

  function clearSignedState() {
    clearSignatureExpirationTimer();
    clearTermsSignedSession();
    signedAtInSession = "";
    signedInSession = false;

    document.querySelectorAll("[data-terms-checkbox]").forEach(function (checkbox) {
      checkbox.checked = false;
    });

    resetPanelStatus();
    scheduleDynamicCheckoutGateRefresh();
  }

  function buildExpiredTermsAttributes(cartAttributes) {
    let attributes = {};

    Object.keys(cartAttributes || {}).forEach(function (key) {
      if (key.indexOf("terms_") === 0) {
        attributes[key] = null;
      }
    });

    attributes[acceptedAtKey] = null;
    attributes[checkboxStateKey] = null;
    attributes[signatureAtKey] = null;
    attributes[signatureNameKey] = null;
    attributes[capturePathKey] = capturePathValues.unknown;
    return attributes;
  }

  function clearExpiredTermsCartAttributes(cartAttributes) {
    if (signatureExpirationCleanupPromise) {
      return signatureExpirationCleanupPromise;
    }

    let cartAttributesPromise = cartAttributes
      ? Promise.resolve(cartAttributes)
      : fetchCartState().then(function (cart) {
          return cart.attributes || {};
        });

    signatureExpirationCleanupPromise = cartAttributesPromise
      .then(function (currentAttributes) {
        return updateCartAttributes(buildExpiredTermsAttributes(currentAttributes));
      })
      .catch(function () {
        return null;
      })
      .then(function (result) {
        signatureExpirationCleanupPromise = null;
        return result;
      });

    return signatureExpirationCleanupPromise;
  }

  function expireTermsSignature(cartAttributes) {
    clearSignedState();
    return clearExpiredTermsCartAttributes(cartAttributes);
  }

  function scheduleSignatureExpiration(signedAt) {
    clearSignatureExpirationTimer();

    let signedAtTimestamp = getSignatureTimestamp(signedAt);

    if (signedAtTimestamp === null) {
      expireTermsSignature();
      return;
    }

    let expiresInMs = signedAtTimestamp + signatureValidityMs - Date.now();

    if (expiresInMs <= 0) {
      expireTermsSignature();
      return;
    }

    signatureExpirationTimer = window.setTimeout(function () {
      expireTermsSignature();
    }, expiresInMs);
  }

  function restoreTermsSignedSessionRecord(record) {
    if (!record || !record.signatureName) {
      return false;
    }

    if (isSignatureExpired(record.signedAt)) {
      clearSignedState();
      return false;
    }

    markSigned(record.signatureName, record.signedAt || "", record.cartToken || "");
    return true;
  }

  function restoreTermsSignedStateFromSession() {
    return restoreTermsSignedSessionRecord(readTermsSignedSession());
  }

  function restoreTermsSignedCartAttributes(signatureName, signedAt) {
    let attributes = {};
    attributes[acceptedAtKey] = signedAt || getIsoTimestamp();
    attributes[capturePathKey] = capturePathValues.cartEsign;
    attributes[checkboxStateKey] = "true";
    attributes[signatureAtKey] = signedAt || getIsoTimestamp();
    attributes[signatureNameKey] = truncateValue(signatureName, 256);
    return updateCartAttributes(attributes);
  }

  function syncTermsSignedSessionWithCart(cart) {
    let attributes = (cart && cart.attributes) || {};
    let cartToken = (cart && cart.token) || "";
    let signatureName = attributes[signatureNameKey];
    let signedAt = attributes[signatureAtKey] || attributes[acceptedAtKey] || "";
    let stored = readTermsSignedSession();

    if (signatureName) {
      if (isSignatureExpired(signedAt)) {
        return expireTermsSignature(attributes);
      }

      markSigned(signatureName, signedAt, cartToken);
      return Promise.resolve(null);
    }

    if (!stored || !stored.signatureName) {
      return Promise.resolve(null);
    }

    if (isSignatureExpired(stored.signedAt)) {
      clearSignedState();
      return Promise.resolve(null);
    }

    if (stored.cartToken && cartToken && stored.cartToken !== cartToken) {
      clearSignedState();
      return Promise.resolve(null);
    }

    markSigned(stored.signatureName, stored.signedAt || "", cartToken || stored.cartToken || "");
    return restoreTermsSignedCartAttributes(stored.signatureName, stored.signedAt || "");
  }

  function markSigned(signatureName, signedAt, cartToken) {
    signedInSession = true;
    signedAtInSession = signedAt || "";
    writeTermsSignedSession(signatureName, signedAt, cartToken);
    scheduleSignatureExpiration(signedAtInSession);

    document.querySelectorAll("[data-terms-checkbox]").forEach(function (checkbox) {
      checkbox.checked = true;
    });

    updatePanelStatus(signatureName, signedAt);
    scheduleDynamicCheckoutGateRefresh();
  }

  function isSigned() {
    if (signedInSession) {
      if (isSignatureExpired(signedAtInSession)) {
        expireTermsSignature();
        return false;
      }

      return true;
    }

    let checkbox = document.querySelector("[data-terms-checkbox]:checked");
    return Boolean(checkbox);
  }

  function shouldInitTermsAcceptance() {
    if (document.querySelector("[data-terms-checkbox]")) {
      return true;
    }

    return Boolean(
      getThemeSettings().cartTermsConditionsEnable &&
        document.querySelector("[data-terms-modal]"),
    );
  }

  function requiresSignature() {
    return shouldInitTermsAcceptance();
  }

  function saveTermsAcceptance(options) {
    let saveOptions = options || {};
    let now = saveOptions.signatureAt || getIsoTimestamp();
    let firstAt = getFirstAcceptedAt();

    if (!firstAt) {
      firstAt = now;
      rememberFirstAcceptedAt(firstAt);
    }

    return Promise.all([getClientIp(), fetchTermsSnapshot()]).then(function (results) {
      let ip = results[0];
      let termsSnapshot = results[1];
      let evidence = buildEvidenceRecord({
        timestampUtc: now,
        firstAcceptedAtUtc: firstAt,
        ip: ip,
        userAgent: navigator.userAgent || "",
        acceptanceUrl: saveOptions.acceptanceUrl || window.location.href,
        sessionId: getSessionId(),
        checkboxState: true,
        signatureName: saveOptions.signatureName || "",
        signatureAt: saveOptions.signatureAt || now,
        orderNameExpected: saveOptions.orderNameExpected || "",
        nameMatched: saveOptions.nameMatched === true,
        scrolledToEnd: saveOptions.scrolledToEnd === true,
        scrollCompletedAt: saveOptions.scrollCompletedAt || "",
        termsCapturePath: capturePathValues.cartEsign,
        signatureDrawn: Boolean(saveOptions.signatureImageBase64),
        signatureImageFormat: saveOptions.signatureImageBase64 ? "png" : "",
        signatureImageSha256: saveOptions.signatureImageSha256 || "",
        signatureImageChunkCount: saveOptions.signatureImageChunkCount || 0,
        termsSnapshot: termsSnapshot,
      });

      return postTermsEvidenceToConvex(evidence, termsSnapshot, saveOptions.signatureImageBase64 || "")
        .then(function () {
          return { evidenceStored: true };
        })
        .catch(function (error) {
          logEvidenceStoreFailure(error, {
            capturePath: evidence.termsCapturePath,
            sessionId: evidence.sessionId,
            shopDomain: evidence.shopDomain,
            signatureName: evidence.signatureName,
          });

          return { evidenceStored: false };
        })
        .then(function (storeResult) {
          let attributes = flattenEvidenceForCart(
            evidence,
            termsSnapshot,
            saveOptions.signatureImageBase64 || "",
          );

          if (!storeResult.evidenceStored) {
            attributes[evidenceStoreFailedKey] = "true";
          }

          return updateCartAttributes(attributes);
        });
    });
  }

  function closeModal() {
    let elements = getModalElements();

    if (!elements || !elements.modal) {
      return;
    }

    captureModalDraft();
    elements.modal.classList.remove("is-open");
    elements.modal.hidden = true;
    unlockPageScroll();
  }

  function openModal(options) {
    let openOptions = options || {};
    let elements = getModalElements();

    if (!elements || !elements.modal) {
      return Promise.resolve(false);
    }

    modalState.onComplete = openOptions.onComplete || null;
    prepareModalForm();
    elements.modal.hidden = false;
    elements.modal.classList.add("is-open");
    lockPageScroll();

    return loadTermsIntoModal().then(function () {
      return new Promise(function (resolve) {
        runAfterModalLayout(function () {
          let currentElements = getModalElements();
          initSignaturePad();

          if (hasModalDraft() && !isSigned()) {
            restoreModalDraftLayout(currentElements);
          } else {
            refreshTermsModalLayout(currentElements);
          }

          runAfterModalLayout(function () {
            resizeSignaturePad().then(function () {
              let restoreSignaturePromise = hasModalDraft() && !isSigned()
                ? restoreModalDraftSignature()
                : Promise.resolve();

              restoreSignaturePromise.then(function () {
                finalizeModalDraftRestore(currentElements).then(function () {
                  updateSubmitState();
                  resolve(true);
                });
              });
            });
          });
        });
      });
    });
  }

  function handleModalSubmit() {
    let elements = getModalElements();
    let strings = getStrings();

    if (!elements) {
      return;
    }

    if (!modalState.hasScrolledToEnd) {
      setModalError(strings.termsEsignScrollRequired || "Please scroll through all terms before signing");
      return;
    }

    let fullName = elements.signatureName ? elements.signatureName.value.trim() : "";
    let customerName = getCustomerName();

    if (customerName) {
      fullName = customerName;
    }

    if (!fullName) {
      setModalError(strings.termsEsignNameMismatch || "Please enter your full legal name");
      return;
    }

    if (!modalState.signaturePad || modalState.signaturePad.isEmpty()) {
      setModalError(strings.termsEsignDrawRequired || "Please draw your signature before continuing");
      return;
    }

    let signatureImageBase64 = modalState.signaturePad.toPngBase64();

    if (!signatureImageBase64) {
      setModalError(strings.termsEsignDrawRequired || "Please draw your signature before continuing");
      return;
    }

    let signedAt = getIsoTimestamp();
    let storeKey = getThemeSettings().termsEvidenceStoreKey || "";

    if (!storeKey) {
      console.warn("termsAcceptance: missing termsEvidenceStoreKey theme setting");
      setModalError(
        strings.termsEsignSaveError ||
          "Unable to save your signature. Please try again.",
      );
      return;
    }

    elements.submitButton.disabled = true;

    hashText(signatureImageBase64)
      .then(function (signatureImageSha256) {
        return saveTermsAcceptance({
          signatureName: fullName,
          signatureAt: signedAt,
          orderNameExpected: fullName,
          nameMatched: true,
          scrolledToEnd: true,
          scrollCompletedAt: modalState.scrollCompletedAt,
          signatureImageBase64: signatureImageBase64,
          signatureImageSha256: signatureImageSha256,
        });
      })
      .then(function () {
        clearModalDraft();
        markSigned(fullName, signedAt);
        closeModal();

        if (typeof modalState.onComplete === "function") {
          modalState.onComplete();
          modalState.onComplete = null;
        }
      })
      .catch(function (error) {
        console.warn("termsAcceptance: unable to save terms acceptance to cart", error);
        setModalError(
          strings.termsEsignSaveError ||
            "Unable to save your signature. Please try again.",
        );
        elements.submitButton.disabled = false;
      });
  }

  function bindModal() {
    let elements = getModalElements();

    if (!elements) {
      return;
    }

    if (elements.closeButton) {
      elements.closeButton.addEventListener("click", closeModal);
    }

    if (elements.modal) {
      elements.modal.addEventListener("click", function (event) {
        if (event.target === elements.modal) {
          closeModal();
        }
      });
    }

    if (elements.content) {
      elements.content.addEventListener("scroll", handleTermsScroll);
    }

    bindModalScrollGuards();

    if (elements.signatureName) {
      elements.signatureName.addEventListener("input", updateSubmitState);
    }

    if (elements.submitButton) {
      elements.submitButton.addEventListener("click", handleModalSubmit);
    }
  }

  function getCheckoutSurface(container) {
    if (
      container &&
      container.closest(
        ".cart__checkout-wrapper, .cart__page, #CartDrawerForm, .drawer__cart",
      )
    ) {
      return "cart";
    }

    if (
      container &&
      container.closest(".product-single__form, .product-section, [data-product-form]")
    ) {
      return "product";
    }

    if (window.location.pathname.indexOf("/cart") === 0) {
      return "cart";
    }

    if (window.location.pathname.indexOf("/products/") !== -1) {
      return "product";
    }

    return "other";
  }

  function getDynamicCheckoutControl(event) {
    let selector =
      ".shopify-payment-button, .wallet-cart-button, .accelerated-checkout-button, shopify-accelerated-checkout";
    let path =
      event && typeof event.composedPath === "function"
        ? event.composedPath()
        : [event && event.target];

    for (let index = 0; index < path.length; index += 1) {
      let node = path[index];

      if (!node || node.nodeType !== 1) {
        continue;
      }

      if (node.matches && node.matches(selector)) {
        return node;
      }

      if (node.closest) {
        let control = node.closest(selector);

        if (control) {
          return control;
        }
      }
    }

    return null;
  }

  function captureCheckoutDiagnostic(action, options) {
    let diagnosticOptions = options || {};
    let container = diagnosticOptions.container || null;
    let signed = isSigned();
    let surface = getCheckoutSurface(container);
    let termsRequired =
      typeof diagnosticOptions.termsRequired === "boolean"
        ? diagnosticOptions.termsRequired
        : isDynamicCheckoutTermsRequired(container);
    let gatePresent = Boolean(
      container && container.querySelector("." + dynamicCheckoutGateClass),
    );
    let gateReady = Boolean(
      container && container.classList.contains(dynamicCheckoutReadyClass),
    );
    let dedupeKey = [
      action,
      window.location.pathname,
      surface,
      signed,
      termsRequired,
      gatePresent,
      gateReady,
    ].join("|");

    if (checkoutDiagnosticsSeen[dedupeKey]) {
      return;
    }

    checkoutDiagnosticsSeen[dedupeKey] = true;

    if (
      !window.Sentry ||
      typeof window.Sentry.withScope !== "function" ||
      typeof window.Sentry.captureMessage !== "function"
    ) {
      return;
    }

    let payload = {
      action: action,
      cartType: getThemeSettings().cartType || "",
      checkoutSurface: surface,
      eventType: diagnosticOptions.eventType || "",
      gatePresent: gatePresent,
      gateReady: gateReady,
      pagePath: window.location.pathname,
      sessionId: getSessionId(),
      signed: signed,
      termsRequired: termsRequired,
      themeName: getThemeSettings().themeName || "",
      themeVersion: getThemeSettings().themeVersion || "",
    };

    window.Sentry.withScope(function (scope) {
      scope.setFingerprint(["terms-checkout-diagnostic"]);
      scope.setLevel(diagnosticOptions.level || "info");
      scope.setTag("checkoutSurface", surface);
      scope.setTag("diagnosticAction", action);
      scope.setTag("diagnosticType", "terms_checkout_path");
      scope.setTag("gatePresent", String(gatePresent));
      scope.setTag("gateReady", String(gateReady));
      scope.setTag("termsRequired", String(termsRequired));
      scope.setTag("termsSigned", String(signed));
      scope.setContext("termsCheckoutDiagnostic", payload);
      window.Sentry.captureMessage("terms checkout diagnostic");
    });
  }

  function handleCheckoutDiagnosticInteraction(event) {
    let control = getDynamicCheckoutControl(event);

    if (!control) {
      return;
    }

    let container = control.closest(dynamicCheckoutGateSelector);

    if (container && isDynamicCheckoutTermsRequired(container)) {
      return;
    }

    captureCheckoutDiagnostic("dynamic_checkout_ungated_interaction", {
      container: container,
      eventType: event.type,
      level: isSigned() ? "info" : "warning",
    });
  }

  function bindCheckoutDiagnosticInteractions() {
    if (checkoutDiagnosticInteractionsBound) {
      return;
    }

    checkoutDiagnosticInteractionsBound = true;
    document.addEventListener("click", handleCheckoutDiagnosticInteraction, true);
    document.addEventListener("pointerdown", handleCheckoutDiagnosticInteraction, true);
  }

  function isDynamicCheckoutTermsRequired(container) {
    return Boolean(container && container.dataset.termsRequired === "true");
  }

  function shouldAutoTriggerDynamicCheckout(container) {
    return Boolean(
      container.closest(
        ".product-single__form, .product-section, product-form, [data-product-form], .cart__checkout-wrapper, .cart__page, #CartDrawerForm, .drawer__cart",
      ),
    );
  }

  function triggerDynamicCheckout(container) {
    if (!container) {
      return;
    }

    let paymentButton = container.querySelector(
      ".shopify-payment-button__button, .shopify-payment-button button, .wallet-cart-button, .accelerated-checkout-button, button[name='checkout']",
    );

    if (paymentButton) {
      paymentButton.click();
      return;
    }

    let paymentRoot = container.querySelector(".shopify-payment-button, shopify-accelerated-checkout");

    if (paymentRoot) {
      paymentRoot.click();
    }
  }

  function removeDynamicCheckoutGates() {
    document.querySelectorAll("." + dynamicCheckoutGateClass).forEach(function (gate) {
      gate.remove();
    });

    document.querySelectorAll(dynamicCheckoutGateSelector).forEach(function (container) {
      container.classList.add(dynamicCheckoutReadyClass);
    });
  }

  function completeDynamicCheckoutGate(container) {
    captureCheckoutDiagnostic("dynamic_checkout_gate_resumed", {
      container: container,
      eventType: "programmatic",
    });
    removeDynamicCheckoutGates();

    if (!container) {
      return;
    }

    if (shouldAutoTriggerDynamicCheckout(container)) {
      window.setTimeout(function () {
        triggerDynamicCheckout(container);
      }, 0);
    }
  }

  function openTermsGateForContainer(container, event) {
    if (!container || !isDynamicCheckoutTermsRequired(container)) {
      return;
    }

    if (container.classList.contains(dynamicCheckoutReadyClass)) {
      if (!isSigned()) {
        captureCheckoutDiagnostic("dynamic_checkout_ready_unsigned", {
          container: container,
          eventType: event ? event.type : "",
          level: "warning",
        });
      }

      return;
    }

    if (isSigned()) {
      return;
    }

    captureCheckoutDiagnostic("dynamic_checkout_gate_blocked", {
      container: container,
      eventType: event ? event.type : "",
    });

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }

    ensureSignedBeforeAction(function () {
      completeDynamicCheckoutGate(container);
    });
  }

  function handleDynamicCheckoutGateClick(event) {
    openTermsGateForContainer(event.currentTarget.closest(dynamicCheckoutGateSelector), event);
  }

  function handleDynamicCheckoutBlockedInteraction(event) {
    openTermsGateForContainer(event.currentTarget, event);
  }

  function bindDynamicCheckoutCapture(container) {
    if (container.getAttribute(dynamicCheckoutCaptureBoundAttr) === "true") {
      return;
    }

    container.setAttribute(dynamicCheckoutCaptureBoundAttr, "true");
    container.addEventListener("touchstart", handleDynamicCheckoutBlockedInteraction, {
      capture: true,
      passive: false,
    });
    container.addEventListener("pointerdown", handleDynamicCheckoutBlockedInteraction, {
      capture: true,
    });
  }

  function ensureDynamicCheckoutGate(container) {
    if (!isDynamicCheckoutTermsRequired(container)) {
      return;
    }

    if (isSigned()) {
      container.classList.add(dynamicCheckoutReadyClass);
      let existingGate = container.querySelector("." + dynamicCheckoutGateClass);

      if (existingGate) {
        existingGate.remove();
      }

      return;
    }

    container.classList.remove(dynamicCheckoutReadyClass);

    if (container.querySelector("." + dynamicCheckoutGateClass)) {
      return;
    }

    let gate = document.createElement("button");
    gate.type = "button";
    gate.className = dynamicCheckoutGateClass;
    gate.setAttribute("aria-label", "Review and sign terms before wallet checkout");
    gate.addEventListener("click", handleDynamicCheckoutGateClick);
    container.appendChild(gate);
    bindDynamicCheckoutCapture(container);
  }

  function refreshDynamicCheckoutGates() {
    if (!shouldInitTermsAcceptance()) {
      return;
    }

    if (isSigned()) {
      removeDynamicCheckoutGates();
      return;
    }

    document.querySelectorAll(dynamicCheckoutGateSelector).forEach(function (container) {
      ensureDynamicCheckoutGate(container);
    });
  }

  function scheduleDynamicCheckoutGateRefresh() {
    if (dynamicCheckoutRefreshFrame) {
      window.cancelAnimationFrame(dynamicCheckoutRefreshFrame);
    }

    dynamicCheckoutRefreshFrame = window.requestAnimationFrame(function () {
      dynamicCheckoutRefreshFrame = null;
      refreshDynamicCheckoutGates();
    });
  }

  function bindDynamicCheckoutGates() {
    if (dynamicCheckoutObserver) {
      return;
    }

    dynamicCheckoutObserver = new MutationObserver(function () {
      if (isSigned()) {
        return;
      }

      scheduleDynamicCheckoutGateRefresh();
    });

    dynamicCheckoutObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function bindOpenButtons() {
    document.addEventListener("click", function (event) {
      let openButton = event.target.closest("[data-terms-open]");

      if (!openButton) {
        return;
      }

      event.preventDefault();
      openModal();
    });
  }

  function isCheckoutSubmitTermsRequired(submitButton) {
    return Boolean(submitButton && submitButton.dataset.termsRequired === "true");
  }

  function getCheckoutSubmitterFromSubmitEvent(event) {
    if (event.submitter && event.submitter.name === "checkout") {
      return event.submitter;
    }

    if (event.target && event.target.name === "checkout") {
      return event.target;
    }

    let form = event.target;
    let activeElement = document.activeElement;

    if (
      form &&
      form.querySelector &&
      activeElement &&
      activeElement.name === "checkout" &&
      form.contains(activeElement)
    ) {
      return activeElement;
    }

    return null;
  }

  function submitCartCheckout(submitButton) {
    let form = submitButton.closest("form");

    if (!form) {
      return;
    }

    if (typeof form.requestSubmit === "function") {
      form.requestSubmit(submitButton);
      return;
    }

    submitButton.click();
  }

  function handleCartCheckoutSubmit(event) {
    let submitButton = getCheckoutSubmitterFromSubmitEvent(event);

    if (!isCheckoutSubmitTermsRequired(submitButton)) {
      return;
    }

    if (isSigned()) {
      captureCheckoutDiagnostic("cart_checkout_signed", {
        container: submitButton.closest("form"),
        eventType: event.type,
        termsRequired: true,
      });
      return;
    }

    captureCheckoutDiagnostic("cart_checkout_gate_blocked", {
      container: submitButton.closest("form"),
      eventType: event.type,
      termsRequired: true,
    });

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    ensureSignedBeforeAction(function () {
      captureCheckoutDiagnostic("cart_checkout_gate_resumed", {
        container: submitButton.closest("form"),
        eventType: "programmatic",
        termsRequired: true,
      });
      submitCartCheckout(submitButton);
    });
  }

  function bindCartCheckoutForms() {
    document.querySelectorAll('button[name="checkout"][data-terms-required="true"]').forEach(function (
      submitButton,
    ) {
      let form = submitButton.closest("form");

      if (!form || form.getAttribute("data-terms-checkout-bound") === "true") {
        return;
      }

      form.setAttribute("data-terms-checkout-bound", "true");
      form.addEventListener("submit", handleCartCheckoutSubmit, true);
    });
  }

  function ensureSignedBeforeAction(onSigned) {
    if (isSigned()) {
      if (typeof onSigned === "function") {
        onSigned();
      }

      return Promise.resolve(true);
    }

    let cleanupPromise = signatureExpirationCleanupPromise || Promise.resolve();

    return cleanupPromise.then(function () {
      return openModal({
        onComplete: onSigned,
      });
    });
  }

  function init() {
    if (!requiresSignature()) {
      return;
    }

    restoreTermsSignedStateFromSession();
    bindModal();
    bindOpenButtons();
    bindCartCheckoutForms();
    bindDynamicCheckoutGates();
    bindCheckoutDiagnosticInteractions();
    initSignaturePad();
    prefetchTermsSnapshot();
    syncCapturePathStateFromCart().then(function () {
      scheduleDynamicCheckoutGateRefresh();
    });
  }

  window.theme = window.theme || {};
  window.theme.termsAcceptance = {
    acceptedAtKey: acceptedAtKey,
    acceptedContentSha256Key: acceptedContentSha256Key,
    acceptanceMethodKey: acceptanceMethodKey,
    acceptanceMethodValue: acceptanceMethodValue,
    acceptanceUrlKey: acceptanceUrlKey,
    applySavedTermsScrollPosition: applySavedTermsScrollPosition,
    bindCartCheckoutForms: bindCartCheckoutForms,
    bindCheckoutDiagnosticInteractions: bindCheckoutDiagnosticInteractions,
    bindDynamicCheckoutGates: bindDynamicCheckoutGates,
    bindOpenButtons: bindOpenButtons,
    buildEvidenceRecord: buildEvidenceRecord,
    buildExpiredTermsAttributes: buildExpiredTermsAttributes,
    captureCheckoutDiagnostic: captureCheckoutDiagnostic,
    captureContentScrollDraft: captureContentScrollDraft,
    captureModalDraft: captureModalDraft,
    capturePathKey: capturePathKey,
    capturePathValues: capturePathValues,
    checkboxStateKey: checkboxStateKey,
    clearExpiredTermsCartAttributes: clearExpiredTermsCartAttributes,
    chunkContent: chunkContent,
    clearModalDraft: clearModalDraft,
    clearSignedState: clearSignedState,
    clearTermsSignedSession: clearTermsSignedSession,
    closeModal: closeModal,
    contentCapturedAtKey: contentCapturedAtKey,
    contentChunkCountKey: contentChunkCountKey,
    contentChunkPrefix: contentChunkPrefix,
    contentLengthKey: contentLengthKey,
    createSignaturePad: createSignaturePad,
    buildTermsSnapshotFromHtml: buildTermsSnapshotFromHtml,
    createTermsFetchError: createTermsFetchError,
    delayMs: delayMs,
    ensureSignedBeforeAction: ensureSignedBeforeAction,
    evidenceKey: evidenceKey,
    evidenceStoreFailedKey: evidenceStoreFailedKey,
    fetchTermsSnapshot: fetchTermsSnapshot,
    finalizeModalDraftRestore: finalizeModalDraftRestore,
    firstAcceptedAtKey: firstAcceptedAtKey,
    flattenEvidenceForCart: flattenEvidenceForCart,
    getEmbeddedTermsHtml: getEmbeddedTermsHtml,
    getAbsoluteTermsUrl: getAbsoluteTermsUrl,
    getClientIp: getClientIp,
    getCheckoutSurface: getCheckoutSurface,
    getCustomerKey: getCustomerKey,
    getDynamicCheckoutControl: getDynamicCheckoutControl,
    getFirstAcceptedAt: getFirstAcceptedAt,
    getIsoTimestamp: getIsoTimestamp,
    getSessionId: getSessionId,
    getSentryEnvironment: getSentryEnvironment,
    getSignatureTimestamp: getSignatureTimestamp,
    getTermsSha256: getTermsSha256,
    getTermsUrl: getTermsUrl,
    getTermsVersion: getTermsVersion,
    handleCheckoutDiagnosticInteraction: handleCheckoutDiagnosticInteraction,
    hasModalDraft: hasModalDraft,
    hashText: hashText,
    htmlToPlainText: htmlToPlainText,
    initSignaturePad: initSignaturePad,
    ipKey: ipKey,
    isSigned: isSigned,
    isSignatureExpired: isSignatureExpired,
    logEvidenceStoreFailure: logEvidenceStoreFailure,
    lockPageScroll: lockPageScroll,
    logTermsLoadFailure: logTermsLoadFailure,
    nameMatchedKey: nameMatchedKey,
    namesMatch: namesMatch,
    normalizeName: normalizeName,
    openModal: openModal,
    orderNameExpectedKey: orderNameExpectedKey,
    parseEvidenceStoreError: parseEvidenceStoreError,
    prefetchTermsSnapshot: prefetchTermsSnapshot,
    readCachedTermsSnapshot: readCachedTermsSnapshot,
    readTermsSignedSession: readTermsSignedSession,
    restoreTermsSignedCartAttributes: restoreTermsSignedCartAttributes,
    restoreTermsSignedStateFromSession: restoreTermsSignedStateFromSession,
    postTermsEvidenceToConvex: postTermsEvidenceToConvex,
    resolveTermsSnapshotFromSources: resolveTermsSnapshotFromSources,
    rememberFirstAcceptedAt: rememberFirstAcceptedAt,
    refreshDynamicCheckoutGates: refreshDynamicCheckoutGates,
    refreshTermsModalLayout: refreshTermsModalLayout,
    requiresSignature: requiresSignature,
    restoreModalDraft: restoreModalDraft,
    restoreModalDraftLayout: restoreModalDraftLayout,
    restoreModalDraftSignature: restoreModalDraftSignature,
    resizeSignaturePad: resizeSignaturePad,
    save: saveTermsAcceptance,
    scheduleSignatureExpiration: scheduleSignatureExpiration,
    scrollCompletedAtKey: scrollCompletedAtKey,
    scrolledToEndKey: scrolledToEndKey,
    sessionIdKey: sessionIdKey,
    setCapturePath: setCapturePath,
    sha256Key: sha256Key,
    signatureAtKey: signatureAtKey,
    signatureDrawnKey: signatureDrawnKey,
    signatureImageSha256Key: signatureImageSha256Key,
    signatureValidityMs: signatureValidityMs,
    signatureDecodeUrl: signatureDecodeUrl,
    signatureDecodeUrlKey: signatureDecodeUrlKey,
    signatureNameKey: signatureNameKey,
    syncCapturePathStateFromCart: syncCapturePathStateFromCart,
    syncTermsSignedSessionWithCart: syncTermsSignedSessionWithCart,
    syncTermsScrollState: syncTermsScrollState,
    termsUrlKey: termsUrlKey,
    termsEvidenceStoreUrl: termsEvidenceStoreUrl,
    truncateValue: truncateValue,
    unlockPageScroll: unlockPageScroll,
    updateCartAttributes: updateCartAttributes,
    userAgentKey: userAgentKey,
    versionKey: versionKey,
    writeCachedTermsSnapshot: writeCachedTermsSnapshot,
    writeTermsSignedSession: writeTermsSignedSession,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
    return;
  }

  init();
})();
